"use client";

import { SideNav } from "@/components/SideNav";
import { HomePage } from "@/components/HomePage";

export default function HomePageClient() {
  return (
    <>
      <SideNav />
      <HomePage />
    </>
  );
}
